<template>
    <BaseComponent
        clase="teatros-home-section"
    >
        <div class="col-md-6 col-sm-12" :class="!footer.renovar_abono ? 'disabled' : ''" v-if="!footer.ocultar_renovar_abono"> 
            <router-link
                v-if="footer.renovar_abono"
                :to="{ name: 'front.abonos.renovar.index' }"
            >
                
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span>
                    {{ $t('home.renovar', {abono : teatro.texto_abono}) }}
                </span>
                
            </router-link>

            <a href="#" v-else>
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span><del>{{ $t('home.renovar', {abono : teatro.texto_abono}) }}</del></span>
            </a>
        </div>
        <div class="col-md-6 col-sm-12" :class="!footer.nuevo_abono ? 'disabled' : ''" v-if="!footer.ocultar_abonos">
            <router-link 
                v-if="footer.nuevo_abono"
                :to="{ name: 'front.abonos.nuevo.index' }"
            >
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span>
                    {{ etiquetaNuevoAbono }}
                </span>
            </router-link>

            <a href="#" v-else>
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span><del>{{ etiquetaNuevoAbono }}</del></span>
            </a>
        </div>
        <div class="col-md-6 col-sm-12" :class="!footer.partidos ? 'disabled' : ''" v-if="!footer.ocultar_eventos">
            <router-link
                v-if="footer.partidos"
                :to="{ name: 'front.eventos.index' }"
            >
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span>{{ teatro.hash === 'THg5WSUAZvlA46M8dD6O' ? 'MUSEOS Y EVENTOS' : $t('home.eventos') }}</span>
            </router-link>
            <a href="#" v-else>
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span><del>{{ teatro.hash === 'THg5WSUAZvlA46M8dD6O' ? 'MUSEOS Y EVENTOS' : $t('home.eventos') }}</del></span>
            </a>
        </div>
        <div class="col-md-6 col-sm-12" :class="!footer.activar_productos ? 'disabled' : ''" v-if="!footer.ocultar_productos">
            <router-link
                v-if="footer.activar_productos"
                :to="{ name: 'front.productos.index' }"
            >
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span>{{ $t('productos.productos') }}</span>
            </router-link>
            <a href="#" v-else>
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span><del>{{ $t('productos.productos') }}</del></span>
            </a>
        </div>
        <div class="col-md-6 col-sm-12" v-if="!footer.ocultar_acreditaciones">
            <router-link
                v-if="footer.activar_acreditaciones"
                :to="{ name: 'front.acreditacion' }"
            >
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span>{{ $t('home.acreditacion') }}</span>
            </router-link>
            <a href="#" v-else>
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span><del>{{ $t('home.acreditacion') }}</del></span>
            </a>
        </div>
    </BaseComponent>
</template>

<script>
    import BaseComponent from '@/components/frontend/home/BaseComponent';
    import { TEATRO_HASH_LA_MAR_DE_MUSICAS } from '@/constants/teatros';

    export default {
        components: {
            BaseComponent
        },
        computed: {
            /**
             * Rótulo de "nuevo abono": manda el botón configurado; si no,
             * La Mar de Músicas tiene el suyo, Talavera el suyo y el resto el
             * genérico con el nombre que cada teatro da al abono.
             */
            etiquetaNuevoAbono() {
                // Primero los textos propios de cada teatro: si uno quiere el
                // suyo, no debe quedar tapado por el botón de la lista.
                if (this.teatro?.hash === TEATRO_HASH_LA_MAR_DE_MUSICAS) {
                    return this.$t('home.nuevo_abono_lamardemusicas');
                }

                if (this.teatro?.hash === '8IuCwC47T9n0qgn2ky0G') {
                    return this.$t('home.nuevo_abono_talavera', { abono: this.teatro?.texto_abono.toUpperCase() });
                }

                // Penúltimo: el botón que el teatro haya configurado en su lista.
                if (this.lista?.btn_nuevo_abono) {
                    return this.lista.btn_nuevo_abono;
                }

                return this.$t('home.nuevo_abono', { abono: this.teatro?.texto_abono });
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            logo() {
                if(this.footer.logo_teatros) {
                    return this.footer.logo_teatros;
                }
                return this.footer.logo;
            },
            lista(){
                return this.$store.getters.getListaAbonados;
            },
            teatro(){
                return this.$store.getters.getTeatro
            }
        }
    }
</script>


